/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { ReactComponent as Barcode } from "assets/icons/barcode.svg";
import { barcodeData } from "Services/Stock";
import { Toast } from "components";
import { BarcodeFieldProps } from "./BarcodeField.props";
import style from "./style.module.scss";

const TIME_INTERVAL: number = 500;
let typingTimer: ReturnType<typeof setTimeout>;

const BarcodeField = React.memo<BarcodeFieldProps>(
    ({
        className,
        showBarcodeModal,
        setFoodData,
        dataObject,
        isWaste = false,
        isStock = false,
        isSingleProduct = false,
        toggelAllowGetSingleProductData,
    }) => {
        const [callAPI, setCallAPI] = useState(false);
        const [error, setError] = useState(false);
        const [inputValue, setInputValue] = useState("");
        const [toast, setToast] = useState(false);
        const { data: barcodes } = useQuery(["barcodes"], barcodeData);

        useEffect(() => {
            //@ts-ignore
            const object = barcodes?.data[inputValue];
            if (callAPI) {
                if (isWaste || isStock) {
                    if (object) {
                        setError(false);
                        setFoodData(object);
                        setCallAPI(false);
                        setInputValue("");
                        if (isSingleProduct) {
                            toggelAllowGetSingleProductData?.();
                        } else {
                            showBarcodeModal(true);
                        }
                    } else {
                        setError(true);
                        setCallAPI(false);
                        setToast(true);
                        setTimeout(() => {
                            setInputValue("");
                            setError(false);
                        }, 100);
                        setTimeout(() => {
                            setToast(false);
                        }, 2000);
                    }
                } else {
                    setError(false);
                    if (object.vendor_id === dataObject.vendor_id) {
                        setFoodData(object);
                        showBarcodeModal(true);
                        setInputValue("");
                        setCallAPI(false);
                    } else {
                        setError(true);
                        setCallAPI(false);
                        setToast(true);
                        setTimeout(() => {
                            setInputValue("");
                            setError(false);
                        }, 500);
                        setTimeout(() => {
                            setToast(false);
                        }, 2000);
                    }
                }
            }
        }, [callAPI, barcodes]);

        const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setInputValue(event.target.value);

            if (typingTimer) clearTimeout(typingTimer);

            typingTimer = setTimeout(() => {
                setCallAPI(true);
            }, TIME_INTERVAL);
        };

        return (
            <div
                className={`
            ${style.fullFieldResponsive} d-flex justify-content-center align-items-center
        `}
                data-testid="BarcodeField"
            >
                <input
                    className={`
                    ${error ? style.errorBarcodeBtn : ""}
                    ${className ? className : ""}
                    ${style.barcodeBtn}
                `}
                    placeholder="وارد کردن بارکد اسکنر"
                    id="barcode"
                    type="text"
                    value={inputValue}
                    onChange={handleOnChange}
                    autoFocus
                ></input>
                <Barcode className={style.barcodeIcon} />
                <Toast
                    className="danger"
                    isShow={toast}
                    title="بارکد مورد نظر یافت نشد."
                />
            </div>
        );
    }
);

export default BarcodeField;
